import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M14.75,8a.76.76,0,0,1-.75.75H7.7l2.88,2.77a.75.75,0,0,1,0,1.06.78.78,0,0,1-.54.23.73.73,0,0,1-.52-.21L5.32,8.54a.85.85,0,0,1-.17-.25.73.73,0,0,1,0-.58.74.74,0,0,1,.17-.25L9.54,3.39a.75.75,0,0,1,1.06,0,.75.75,0,0,1,0,1.06L7.7,7.25H14A.75.75,0,0,1,14.75,8Zm-12,6V2a.75.75,0,0,0-1.5,0V14a.75.75,0,0,0,1.5,0Z';
const draw24px = 'M20.75,12a.75.75,0,0,1-.75.75H10.49L12.76,15a.74.74,0,0,1,0,1.06.75.75,0,0,1-.53.22.79.79,0,0,1-.53-.22L8.15,12.53A.78.78,0,0,1,8,12.29a.73.73,0,0,1,0-.58.78.78,0,0,1,.16-.24L11.7,7.92a.75.75,0,0,1,1.06,0,.74.74,0,0,1,0,1.06l-2.27,2.27H20A.76.76,0,0,1,20.75,12Zm-16,8V4a.75.75,0,0,0-1.5,0V20a.75.75,0,0,0,1.5,0Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const ArrowAlignLeftIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'arrowAlignLeft'));
ArrowAlignLeftIcon.displayName = 'ArrowAlignLeftIcon';
ArrowAlignLeftIcon.propTypes = Icon.propTypes;
ArrowAlignLeftIcon.renderIcon = props => /*#__PURE__*/React.createElement(ArrowAlignLeftIcon, props);
export default ArrowAlignLeftIcon;
//# sourceMappingURL=ArrowAlignLeftIcon.js.map